import { Col, Form, Radio } from 'antd'

import { TFieldProps } from '..'
import { Rule } from 'antd/es/form'

import './styles.scss'

export default function BooleanFormField({ fieldInfo }: TFieldProps) {
  const setFieldRules = (): Rule[] => {
    const rules: Rule[] = []

    if (fieldInfo.required) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }

  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`boolean-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <Radio.Group size='small'>
          <Radio value={true}>Sí</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      </Form.Item>
    </Col>
  )
}
